import {
  GenericQueryParamsType,
  GenericResponse,
  TerminalType,
} from '../types';
import { getHeaders, tosApi } from './tosApi';

type TerminalQueryParamsType = GenericQueryParamsType & {
  complete_filter?: string;
};

export const terminalApi = tosApi.injectEndpoints({
  endpoints: (build) => ({
    getTerminals: build.query<
      GenericResponse & { results: Array<TerminalType> },
      TerminalQueryParamsType | void
    >({
      query: (params: GenericQueryParamsType) => {
        return {
          url: `/maritime/terminals`,
          method: 'GET',
          headers: getHeaders,
          params,
        };
      },
      providesTags: () => [{ type: 'Terminal', code: '2' }],
    }),
    getTerminal: build.query<
      { results: Array<TerminalType> },
      { name?: string }
    >({
      query: (arg) => {
        const { name } = arg;
        return {
          url: '/maritime/terminals',
          method: 'GET',
          headers: getHeaders,
          params: { name },
        };
      },
    }),
    createTerminal: build.mutation<TerminalType, TerminalType>({
      query: (terminal) => {
        return {
          url: `/maritime/terminals`,
          method: 'POST',
          body: terminal,
        };
      },
      invalidatesTags: () => [{ type: 'Terminal', code: '2' }],
    }),
    updateTerminal: build.mutation<TerminalType, TerminalType>({
      query: (terminal) => {
        return {
          url: `/maritime/terminals/${terminal.id}`,
          method: 'PUT',
          body: terminal,
        };
      },
      invalidatesTags: () => [{ type: 'Terminal', code: '2' }],
    }),
    deleteTerminal: build.mutation<TerminalType, number>({
      query: (id) => {
        return {
          url: `/maritime/terminals/${id}`,
          method: 'DELETE',
        };
      },
    }),
  }),
  overrideExisting: true,
});

export const {
  useGetTerminalsQuery,
  useLazyGetTerminalsQuery,
  useGetTerminalQuery,
  useCreateTerminalMutation,
  useUpdateTerminalMutation,
  useDeleteTerminalMutation,
} = terminalApi;
